/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Dangerzone2Inputs */

const zh_settingsnav_dangerzone2 = /** @type {(inputs: Settingsnav_Dangerzone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`危险区域`)
};

const en_settingsnav_dangerzone2 = /** @type {(inputs: Settingsnav_Dangerzone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danger Zone`)
};

const es_settingsnav_dangerzone2 = /** @type {(inputs: Settingsnav_Dangerzone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona de peligro`)
};

/**
* | output |
* | --- |
* | "Danger Zone" |
*
* @param {Settingsnav_Dangerzone2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_dangerzone2 = /** @type {((inputs?: Settingsnav_Dangerzone2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Dangerzone2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_dangerzone2(inputs)
	if (locale === "en") return en_settingsnav_dangerzone2(inputs)
	return es_settingsnav_dangerzone2(inputs)
});
export { settingsnav_dangerzone2 as "settingsNav_dangerZone" }